// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1299": "754f19b5477e","5257": "af5c27c4fdfc","5707": "d54337948687","6863": "454c9f289029","9131": "728075e03bd1","9997": "77539fc7a97a",}[chunkId] + ".css"
}